<!--
@Author: Calvin Green <calvin>
@Date:   2022-01-11T13:51:01+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-02-01T10:43:40+02:00
@Copyright: Diversitude 2021
-->



<template>
    <Layout>
        <b-row>
            <b-col xl="2"  sm="3" v-show="showDefaultScreen">
                <keep-alive>
                    <Menu @back="handleBack"/>
                </keep-alive>
            </b-col>

            <b-col xl="10"  sm="9" v-if="showDefaultScreen">
                <Crumbs/>
                <Documents
                @edit="editDoc"
                @createNew="newDoc"
                @showStats="showStatsHandler"
                @showDistribution="showDistributionHandler"
                v-if="isEditing == false && isEditingClient == false"/>
                <Edit @back="isEditing = false;" :isNewDocument="isNewDocument" v-if="isEditing && isEditingClient == false"/>
                <ClientEdit v-else-if="isEditingClient" @back="isEditingClient = false;" />
            </b-col>
            <b-col cols="12" v-else-if="showStats">
                <div class="d-flex">
                    <i @click="handleBack" style="font-size: 4rem;" class="fas fa-times text-light mb-4 pb-2 me-4"></i>
                    <Crumbs class="w-100" />
                </div>
                <Stats @editClientSop="editClientSopHandler" />
            </b-col>
            <b-col cols="12" v-else-if="showDistribution">
                <Distribution  @back="handleBack" />
            </b-col>
        </b-row>
    </Layout>
</template>

<script>
import Menu from '@/components/widgets/green-menu.vue'
import Layout from "../../layouts/main-stripped";
import Crumbs from '@/components/widgets/breadcrumbs.vue';
import Documents from '@/components/admin/ccb_documents/documentList.vue'
import Edit from '@/components/admin/ccb_documents/editDocument.vue';
import ClientEdit from '@/components/admin/ccb_documents/editClientDocument.vue';

import Stats from '@/components/admin/ccb_documents/stats.vue'
import Distribution from '@/components/admin/ccb_documents/distribution.vue'

import {layoutMethods} from '@/state/helpers';
export default {
    data:() => ({
        isEditing: false,
        isEditingClient: false,
        isNewDocument: false,
        hideMenu: false,

        showStats: false,
        showDistribution: false,
    }),
    components:{
        Layout,
        Crumbs,
        Menu,
        Documents,
        Edit,
        ClientEdit,
        Stats,
        Distribution
    },
    computed: {
        showDefaultScreen(){
            if(this.showStats == false && this.showDistribution == false){
                return true;
            }
            else{
                return false;
            }
        }
    },
    methods: {
        ...layoutMethods,
        handleBack(){
            this.showDocumentsMenu();
            this.isEditing = false;
            this.isEditingClient = false;
            this.showStats = false;
            this.showDistribution = false;
        },
        editDoc(id){
            this.showEditMenu();
            console.log(id);
            this.isNewDocument = false;
            this.isEditing = true;
        },
        newDoc(){
            this.isNewDocument = true;
            this.isEditing = true;
            this.showEditMenu();
        },
        showDocumentsMenu(){
            this.updateMenuType({
                type: 'documents',
                showMenu: true,
                showRoutes: false,
            })
        },
        showEditMenu(){
            this.hideMenu = false;
            this.updateMenuType({
                type: 'document_edit',
                showMenu: false,
                showRoutes: false,
            })
        },

        //* document right click events */
        showStatsHandler(){
            this.hideMenu = true;

            this.isEditing = false;
            this.showStats = true;
            this.showDistribution = false,

            this.updateMenuType({
                type: 'stats',
                showMenu: false,
                showRoutes: false,
            })
        },
        showDistributionHandler(){
            this.hideMenu = true;

            this.isEditing = false;
            this.showStats = false;
            this.showDistribution = true;

            this.updateMenuType({
                type: 'distribution',
                showMenu: false,
                showRoutes: false,
            })
        },
        editClientSopHandler(){
            this.hideMenu = true;
            this.updateMenuType({
                type: 'for_client_document',
                showMenu: false,
                showRoutes: false,
            });
            this.showStats = false;
            this.isEditingClient = true;
        }
    },
    mounted(){
        this.$nextTick(()=>{
            this.updateMenuType({
                type: 'documents',
                showMenu: true,
                showRoutes: false,
            })
        })
    },
    beforeDestroy(){
        this.updateMenuType({
            type: 'Nothing',
            showMenu: true,
            showRoutes: false,
        })
    },
}
</script>

<style>

</style>
